import { Button, Stack, TextField, Typography } from "@mui/material";

import { useToast } from "@qubit/autoparts";
import { useState } from "react";

import { ViewNameTranslation } from "~/hooks/useNavbar";
import { usePostOrdersByOrderIdCancelMutation } from "~/redux/public/orders.openApi";

export type CancelOrdersPageProps = { viewTitle?: ViewNameTranslation };

export const CancelOrdersPage = () => {
  const { successToast, errorToast } = useToast();
  const [orderId, setOrderId] = useState("");

  const [cancelOrder] = usePostOrdersByOrderIdCancelMutation();

  const handleClick = async (orderId: string) => {
    try {
      await cancelOrder({ orderId }).unwrap();
      successToast("Order has been cancelled.");
    } catch {
      errorToast("Order could not be cancelled.");
    }
  };

  return (
    <>
      <Typography variant="h6" sx={{ my: 2 }}>
        Please Enter the Order ID to Cancel:
      </Typography>
      <TextField
        id="order-id-input"
        label="Order ID"
        variant="outlined"
        fullWidth
        sx={{ mb: 2 }}
        onChange={(e) => setOrderId(e.target.value)}
      />

      <Stack direction="column" gap={3}>
        <Stack direction="row" gap={3}>
          <Button
            type="submit"
            color="primary"
            role="button"
            aria-label="Cancel Order"
            disabled={!orderId.length}
            onClick={() => handleClick(orderId)}
          >
            Cancel Order
          </Button>
        </Stack>
      </Stack>
    </>
  );
};
